export default __webpack_public_path__ + "static/0039-6f26823c6f35ffd567623a35d89a2d34.png";